"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { useLocale, useTranslations } from "next-intl";
import { useEventListener } from "usehooks-ts";
import { TextParagraph, useTheme } from "@ops-gsic/cxp-component-library-react";
import NotificationIcon from "@/assets/icons/ontario-icon-notification.svg";
import UnreadMarkerIcon from "@/assets/icons/unread-marker.svg";
import { NotificationButton, NotificationBadge, NotificationPopover, NotificationContent, StyledMessageLink, NotificationItem, NotificationTitle, NotificationMessage, NotificationDate, NotificationHeader, NotificationItemContent, NotificationText, NotificationUnread } from "./styles";
import { formatMessageDate } from "@/utils/formatters/formatMessageDate";
import { useAppConfig } from "@/context/AppConfigProvider";
import { Message } from "@/types/inbox";
type NotificationMenuProps = {
  messages: Message[];
  unreadCount: number;
};
export const NotificationMenu = t0 => {
  const $ = _c(21);
  const {
    messages: t1,
    unreadCount: t2
  } = t0;
  const messages = t1 === undefined ? [] : t1;
  const unreadCount = t2 === undefined ? 0 : t2;
  const [isOpen, setIsOpen] = useState(false);
  const locale = useLocale();
  const t = useTranslations("Common.components.AppHeader.notifications");
  const {
    theme
  } = useTheme();
  const {
    appConfig
  } = useAppConfig();
  const buttonRef = useRef(null);
  const popoverRef = useRef(null);
  let t3;
  if ($[0] !== isOpen) {
    t3 = event => {
      const target = event.target as Node;
      const clickedInsideButton = buttonRef.current?.contains(target) ?? false;
      const clickedInsidePopover = popoverRef.current?.contains(target) ?? false;
      if (isOpen && !clickedInsideButton && !clickedInsidePopover) {
        setIsOpen(false);
      }
    };
    $[0] = isOpen;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  useEventListener("mousedown", t3);
  let t4;
  if ($[2] !== isOpen) {
    t4 = event_0 => {
      if (isOpen && event_0.key === "Escape") {
        setIsOpen(false);
      }
    };
    $[2] = isOpen;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useEventListener("keydown", t4);
  const visibleMessages = [...messages].sort(_temp).slice(0, 3);
  const getMessagePreview = _temp2;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsOpen(_temp3);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t("buttonTitle");
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t) {
    t7 = t("ariaLabel");
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = theme?.color?.white;
  let t9;
  if ($[9] !== t8) {
    t9 = <NotificationIcon aria-hidden="true" focusable="false" color={t8} className="ontario-icon" />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== unreadCount) {
    t10 = unreadCount > 0 && <NotificationBadge>{unreadCount}</NotificationBadge>;
    $[11] = unreadCount;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t6 || $[15] !== t7 || $[16] !== t9) {
    t11 = <NotificationButton ref={buttonRef} onClick={t5} title={t6} aria-label={t7}>{t9}{t10}</NotificationButton>;
    $[13] = t10;
    $[14] = t6;
    $[15] = t7;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = isOpen && <NotificationPopover ref={popoverRef}><NotificationHeader><NotificationTitle> {t("inboxHeading")}</NotificationTitle>{(!messages?.length || unreadCount === 0) && <TextParagraph aria-live="polite">{t("noNewMessages")}</TextParagraph>}</NotificationHeader><NotificationContent>{unreadCount > 0 && visibleMessages.map(message => <NotificationItem key={message.messageId}><StyledMessageLink href={`${appConfig?.cxpWebBasePath}/${locale}/notifications/message?messageId=${message.messageId}`}><NotificationItemContent><NotificationUnread>{!message.isRead && <UnreadMarkerIcon aria-hidden="true" focusable="false" />}</NotificationUnread><NotificationText><NotificationTitle isRead={message.isRead}>{message.subject}</NotificationTitle><NotificationMessage>{getMessagePreview(message.body)}</NotificationMessage><NotificationDate>{formatMessageDate(message.messageDateTime, locale)}</NotificationDate></NotificationText></NotificationItemContent></StyledMessageLink></NotificationItem>)}{messages.length > 0 && unreadCount > 0 && <NotificationItem className="view-inbox-item"><a href={`${appConfig?.cxpWebBasePath}/${locale}/notifications/inbox`}>{t("viewMyInbox")}</a></NotificationItem>}</NotificationContent></NotificationPopover>;
  let t13;
  if ($[18] !== t11 || $[19] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};
function _temp(a, b) {
  return Date.parse(b.messageDateTime) - Date.parse(a.messageDateTime);
}
function _temp2(messageBody) {
  const parsedMessage = new DOMParser().parseFromString(messageBody ?? "", "text/html");
  return parsedMessage.body.textContent?.replace(/\s+/g, " ").trim() ?? "";
}
function _temp3(v) {
  return !v;
}